import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx';

import { toast } from 'react-toastify';

import api from '../../../services/api';
import history from '../../../services/history';
import { opImport } from '../../../lib/csv-core';
import { AppError } from '../../../errors/AppError';

import TitleBar from '../../TitleBar';
import { FormWrapper, Form, ModeloButton } from '..';
import { Table, RowMaster } from '../../Table';
import TableHeader from '../../Table/TableHeader';
import { ImportacaoInput } from './ImportacaoInput';
import Loading from '../../Loading';
import { opIdioma } from '../../../lib/inputOption';

import Icon from '../../../assets/upload.svg';
import { Container as UploadContainer } from './ImportacaoInput/styles';

function Importacao() {
  const location = useLocation();
  const { parametros } = location.state;

  const formRef = useRef();
  const [error, setError] = useState(null);

  const [title, setTitle] = useState('');
  const [params, setParams] = useState({ op: '' });
  const [loading, setLoading] = useState(false);
  /** idioma default enviado como fallback ao backend — só é usado no
   * layout legado (14 colunas); no modelo multilíngue (50 colunas) cada
   * coluna já traz seu próprio idioma e este valor é ignorado. O seletor
   * de idioma foi removido do modal de importação de níveis pois deixou
   * de ser necessário. */
  const idioma = opIdioma[0].value;

  const [updatePNItems, setUpdatePNItems] = useState([]);
  const [updatePNFileName, setUpdatePNFileName] = useState('');

  useEffect(() => {
    const fmtParametros = { ...parametros, idioma };
    setParams(fmtParametros);
  }, [parametros, idioma]);

  // const handleModelo = useCallback(async () => {
  //   try {
  //     /** requisição de modelo para o servidor */
  //     const response = await api.get(`download/modelo-${params.op}.csv`, {
  //       responseType: 'blob',
  //     });

  //     /** baixa o arquivo na máquina local */
  //     const url = URL.createObjectURL(new Blob([response.data]));

  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.download = `importacao-${params.op}.csv`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (err) {
  //     AppError(err);
  //   }
  // }, [params]);

  const handleModeloUpdatePN = useCallback(() => {
    const worksheet = XLSX.utils.json_to_sheet([
      {
        // IDMATERIAL: 123456,
        PARTNUMBER_ATUAL: 'ATUAL-CODIGO-001',
        NOVO_PARTNUMBER: 'NOVO-CODIGO-001',
      },
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Atualizacao PN');
    XLSX.writeFile(workbook, 'modelo-empresa-update-pn.xlsx');
  }, []);

  /** OBS: o modelo de itens do catalogo agora e baixado do servidor
   * (temp/download/modelos/modelo-catalogo-item.csv), que ja contem as
   * colunas DESCRICAO_BR..ES (14 colunas). A geracao client-side
   * condicionada ao fabricante multi-idioma foi removida: o parser do
   * backend detecta o layout pela quantidade de colunas (8 = legado,
   * 14 = multilingue) para qualquer fabricante. */

  const handleModelo = useCallback(async () => {
    try {
      if (params.op === opImport.UPDATE_PARTNUMBER) {
        handleModeloUpdatePN();
        return;
      }

      /** cache-busting: evita que o navegador reaproveise uma resposta
       * antiga em cache para esta mesma URL quando o arquivo de modelo
       * é atualizado no servidor */
      const response = await api.get(
        `download/modelo-${params.op}.csv?v=${Date.now()}`,
        {
          responseType: 'blob',
        }
      );

      const url = URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;
      link.download = `modelo-${params.op}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      AppError(err);
    }
  }, [params, handleModeloUpdatePN]);

  const normalizarColunaExcel = useCallback(
    (value) =>
      String(value || '')
        .trim()
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_'),
    []
  );

  const buscarValorColunaExcel = useCallback(
    (row, nomesPermitidos) => {
      const key = Object.keys(row).find((coluna) =>
        nomesPermitidos.includes(normalizarColunaExcel(coluna))
      );

      return key ? row[key] : undefined;
    },
    [normalizarColunaExcel]
  );

  // const handleExcelUpdatePN = useCallback(
  //   async (e) => {
  //     try {
  //       setError(null);
  //       setUpdatePNItems([]);

  //       const file = e.target.files[0];

  //       if (!file) {
  //         AppError('Nenhum arquivo de importação fornecido');
  //         return;
  //       }

  //       setUpdatePNFileName(file.name);
  //       setLoading(true);

  //       const buffer = await file.arrayBuffer();
  //       const workbook = XLSX.read(buffer, { type: 'array' });
  //       const primeiraAba = workbook.SheetNames[0];
  //       const worksheet = workbook.Sheets[primeiraAba];

  //       if (!worksheet) {
  //         AppError('A planilha não possui abas para leitura');
  //         return;
  //       }

  //       const rows = XLSX.utils.sheet_to_json(worksheet, {
  //         defval: '',
  //         raw: false,
  //       });

  //       if (!rows.length) {
  //         AppError('A planilha não possui registros para importar');
  //         return;
  //       }

  //       const validacoes = [];
  //       const registros = [];

  //       rows.forEach((row, index) => {
  //         const linha = index + 2;

  //         const atualPartnumberRaw = buscarValorColunaExcel(row, [
  //           // 'IDMATERIAL',
  //           // 'ID_MATERIAL',
  //           'PARTNUMBERATUAL',
  //           'PARTNUMBER_ATUAL',
  //           'ATUAL_PARTNUMBER',
  //           'ATUALPARTNUMBER',
  //         ]);

  //         const novoPartnumberRaw = buscarValorColunaExcel(row, [
  //           'NOVO_PARTNUMBER',
  //           'NOVOPARTNUMBER',
  //           'PARTNUMBER_NOVO',
  //           'PARTNUMBERNOVO',
  //         ]);

  //         const atualPartnumber = String(atualPartnumberRaw).trim();
  //         const novoPartnumber = String(novoPartnumberRaw || '').trim();

  //         const mensagens = [];

  //         if (!atualPartnumberRaw || Number.isNaN(atualPartnumber)) {
  //           mensagens.push(
  //             'Coluna PARTNUMBER_ATUAL deve ser numérica e obrigatória'
  //           );
  //         }

  //         if (!novoPartnumber) {
  //           mensagens.push('Coluna NOVO_PARTNUMBER é obrigatória');
  //         }

  //         if (mensagens.length > 0) {
  //           validacoes.push({ linha, message: mensagens });
  //           return;
  //         }

  //         registros.push({
  //           linha,
  //           atualPartnumber,
  //           novoPartnumber,
  //         });
  //       });

  //       if (validacoes.length > 0) {
  //         setError(validacoes);
  //         return;
  //       }

  //       if (!registros.length) {
  //         AppError('Nenhum registro válido encontrado na planilha');
  //         return;
  //       }

  //       setUpdatePNItems(registros);
  //       toast.success(`${registros.length} registros lidos com sucesso!`);
  //     } catch (err) {
  //       AppError(err);
  //     } finally {
  //       setLoading(false);
  //       e.target.value = null;
  //     }
  //   },
  //   [buscarValorColunaExcel]
  // );

  const handleExcelUpdatePN = useCallback(
    async (event) => {
      const input = event.currentTarget;
      const file = input && input.files ? input.files[0] : null;

      try {
        setError(null);
        setUpdatePNItems([]);

        if (!file) {
          AppError('Nenhum arquivo de importação fornecido');
          return;
        }

        setUpdatePNFileName(file.name);
        setLoading(true);

        const buffer = await file.arrayBuffer();

        const workbook = XLSX.read(buffer, { type: 'array' });
        const primeiraAba = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[primeiraAba];

        if (!worksheet) {
          AppError('A planilha não possui abas para leitura');
          return;
        }

        const rows = XLSX.utils.sheet_to_json(worksheet, {
          defval: '',
          raw: false,
        });

        if (!rows.length) {
          AppError('A planilha não possui registros para importar');
          return;
        }

        const validacoes = [];
        const registros = [];

        rows.forEach((row, index) => {
          const linha = index + 2;

          const partnumberAtualRaw = buscarValorColunaExcel(row, [
            'PARTNUMBER_ATUAL',
            'PARTNUMBERATUAL',
            'PARTNUMBER',
            'PN_ATUAL',
          ]);

          const novoPartnumberRaw = buscarValorColunaExcel(row, [
            'NOVO_PARTNUMBER',
            'NOVOPARTNUMBER',
            'PARTNUMBER_NOVO',
            'PN_NOVO',
          ]);

          const partnumberAtual = String(partnumberAtualRaw || '').trim();
          const novoPartnumber = String(novoPartnumberRaw || '').trim();

          const mensagens = [];

          if (!partnumberAtual) {
            mensagens.push('Coluna PARTNUMBER_ATUAL é obrigatória');
          }

          if (!novoPartnumber) {
            mensagens.push('Coluna NOVO_PARTNUMBER é obrigatória');
          }

          if (mensagens.length > 0) {
            validacoes.push({ linha, message: mensagens });
            return;
          }

          registros.push({
            linha,
            partnumberAtual,
            novoPartnumber,
          });
        });

        if (validacoes.length > 0) {
          setError(validacoes);
          return;
        }

        if (!registros.length) {
          AppError('Nenhum registro válido encontrado na planilha');
          return;
        }

        setUpdatePNItems(registros);
        toast.success(`${registros.length} registros lidos com sucesso!`);
      } catch (err) {
        AppError(err);
      } finally {
        setLoading(false);

        if (input) {
          input.value = '';
        }
      }
    },
    [buscarValorColunaExcel]
  );

  const handleCriarLoteUpdatePN = useCallback(async () => {
    try {
      if (!params.idEmpresa) {
        AppError('Empresa não identificada para atualização de Partnumber');
        return;
      }

      if (!updatePNItems.length) {
        AppError('Nenhum registro lido para importar');
        return;
      }

      setLoading(true);

      await api.post(`empresa/${params.idEmpresa}/update-pn/lote`, {
        data: updatePNItems.map(({ partnumberAtual, novoPartnumber }) => ({
          partnumberAtual,
          novoPartnumber,
        })),
      });

      toast.success('Lote de atualização de Partnumber criado com sucesso!');
      history.goBack();
    } catch (err) {
      AppError(err);
    } finally {
      setLoading(false);
    }
  }, [params.idEmpresa, updatePNItems]);

  const handleUploadEnd = useCallback(
    ({ message = '', validation = null, filename }) => {
      setLoading(false);

      if (message || (validation && validation.length > 0)) {
        setError(validation);
        AppError(message);
      } else {
        toast.success(
          `Importação${title ? ` de ${title.toLowerCase()}` : ''} concluída!`
        );

        history.goBack();
      }
      /** Se possuir arquivo, faz dowload com informações não processadas */
      if (filename) {
        const link = document.createElement('a');

        link.setAttribute('href', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    [title]
  );

  /** define título da janela */
  useEffect(() => {
    let text;
    switch (params.op) {
      case opImport.PAGINA_ITEMPAGINA:
      case opImport.CATALOGO_ITEMPAGINA:
        text = 'Itens';
        break;
      case opImport.CATALOGO_NIVEL:
        text = 'Niveis';
        break;
      case opImport.CATALOGO_SERIE:
        text = 'Nº de Série';
        break;
      case opImport.EMPRESA_MENU:
        text = 'Menus';
        break;
      case opImport.EMPRESA_SISTEMA:
        text = 'Sistemas';
        break;
      case opImport.EMPRESA_LOCAL:
        text = 'Locais';
        break;
      case opImport.EMPRESA_MOBILIDADE:
        text = 'Mobilidade';
        break;
      case opImport.FABRICANTE:
        text = 'Fabriacantes';
        break;
      case opImport.MODELO:
        text = 'Modelos';
        break;
      case opImport.EMPRESA_MATERIAL_ERP:
        text = 'Materiais ERP';
        break;
      case opImport.UPDATE_PARTNUMBER:
        text = 'Atualização de Partnumber';
        break;
      default:
        text = '';
        break;
    }

    setTitle(text);
  }, [params]);

  return (
    <>
      <TitleBar back={!!location.background} title={`Importação de ${title}`} />
      <FormWrapper>
        <Form ref={formRef} id="formImportacao" autoComplete="off">
          {/* seletor de idioma removido: o modelo de níveis agora traz
              todas as traduções (BR/EN/IT/FR/RU/DE/ES) diretamente nas
              colunas do CSV, então não é mais necessário escolher um
              idioma único antes do upload */}
          <Form.Column>
            {/* <Form.Column alignCenter>
              <ImportacaoInput
                id={`${title.toLowerCase()}Importacao`}
                name={`${title.toLowerCase()}Importacao`}
                parametros={params}
                onUploadStart={() => setLoading(true)}
                onUploadEnd={(data) => handleUploadEnd(data)}
                onClick={() => setError(null)}
              />
              <Form.Row>
                <ModeloButton type="button" onClick={handleModelo}>
                  Baixar Modelo
                </ModeloButton>
              </Form.Row>
            </Form.Column> */}
            <Form.Column alignCenter>
              {params.op === opImport.UPDATE_PARTNUMBER ? (
                <>
                  <UploadContainer>
                    <label htmlFor="updatePNExcelImportacao">
                      <img src={Icon} alt="Excel" />
                      {updatePNFileName || 'Selecione o Excel aqui'}

                      <input
                        type="file"
                        id="updatePNExcelImportacao"
                        accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                        onChange={handleExcelUpdatePN}
                        onClick={() => setError(null)}
                      />
                    </label>
                  </UploadContainer>

                  <Form.Row>
                    <ModeloButton type="button" onClick={handleModelo}>
                      Baixar Modelo
                    </ModeloButton>
                  </Form.Row>
                </>
              ) : (
                <>
                  <ImportacaoInput
                    id={`${title.toLowerCase()}Importacao`}
                    name={`${title.toLowerCase()}Importacao`}
                    parametros={params}
                    onUploadStart={() => setLoading(true)}
                    onUploadEnd={(data) => handleUploadEnd(data)}
                    onClick={() => setError(null)}
                  />

                  <Form.Row>
                    <ModeloButton type="button" onClick={handleModelo}>
                      Baixar Modelo
                    </ModeloButton>
                  </Form.Row>
                </>
              )}
            </Form.Column>
            <>
              {params.op === opImport.UPDATE_PARTNUMBER &&
                updatePNItems.length > 0 && (
                  <Form.Column alignCenter withPadding>
                    <h3>Registros lidos da planilha</h3>

                    <Table>
                      <TableHeader
                        withPadding
                        titles={[
                          // { fieldname: 'linha', title: 'Linha' },
                          {
                            fieldname: 'partnumberAtual',
                            title: 'Partnumber Atual',
                          },
                          {
                            fieldname: 'novoPartnumber',
                            title: 'Novo Partnumber',
                          },
                        ]}
                        cbSort={() => {}}
                      />

                      <tbody>
                        {updatePNItems.map((item) => (
                          <RowMaster
                            key={`${item.linha}-${item.partnumberAtual}`}
                            noCursoPointer
                          >
                            <td>{item.partnumberAtual}</td>
                            <td>{item.novoPartnumber}</td>
                          </RowMaster>
                        ))}
                      </tbody>
                    </Table>
                  </Form.Column>
                )}
              <Form.Row>
                {updatePNItems.length > 0 && (
                  <ModeloButton
                    type="button"
                    onClick={handleCriarLoteUpdatePN}
                    disabled={loading}
                  >
                    Confirmar Importação
                  </ModeloButton>
                )}
              </Form.Row>
            </>
            <Form.Column alignCenter withPadding>
              {error && (
                <>
                  <h3>Erros de validação</h3>
                  <Table>
                    <TableHeader
                      withPadding
                      titles={[
                        { fieldname: 'linha', title: 'Linha' },
                        // colocar fields dinâmicos opcionais (ex.: idPagina dos niveis)?
                        { fieldname: 'message', title: 'Mensagem' },
                      ]}
                      cbSort={() => {}}
                    />
                    <tbody>
                      {error.map((err, idx) => (
                        <RowMaster key={idx} onClick={() => {}}>
                          <td>{err.linha}</td>
                          <td>
                            <ul>
                              {err.message.map((m, i) => (
                                <li key={i}>{m}</li>
                              ))}
                            </ul>
                          </td>
                        </RowMaster>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </Form.Column>
          </Form.Column>
        </Form>
      </FormWrapper>
      <Loading visible={loading} />
    </>
  );
}

export { Importacao };
